import { render } from "./LegacyModal.vue?vue&type=template&id=77411246&scoped=true&ts=true"
import script from "./LegacyModal.vue?vue&type=script&lang=ts"
export * from "./LegacyModal.vue?vue&type=script&lang=ts"

import "./LegacyModal.vue?vue&type=style&index=0&id=77411246&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77411246"]])

export default __exports__